/**
 * Functionality for make-a-payment template
 */
; (function (JQuery) {
	"use strict"
	function FloUnzerPayments() {
		var global = {
			card: false,
		}

		var fn = {
			init: function () {
				if (jQuery('.page-template-template-make-a-payment').length === 1) {
					jQuery('.js-webpay-prev').on('click', fn.triggerPreviousForm);
					jQuery('.js-webpay-noorgs').on('change', fn.triggerOrgFieldDisplay);
					jQuery('.js-webpay-noinvoices').on('change', fn.triggerInvoicesFieldDisplay);
					fn.initialiseUnzerComponentsUi();
				}
				fn.handleUnzerPayment();
			},

			getDomainFromUrl: function (url) {
				var arr = url.split("/");
				return arr[0] + "//" + arr[2];
			},

			triggerPreviousForm: function (e) {
				e.preventDefault();
				jQuery('.js-webpay-prev-form').submit();
			},

			triggerOrgFieldDisplay: function () {
				var noorgs = parseInt(jQuery(this).val());
				jQuery('.js-webpay-orgfield').css('display', 'none');

				jQuery('.js-webpay-orgfield').filter(function () {
					return jQuery(this).attr("data-i") < noorgs;
				}).css('display', 'table');
			},

			triggerInvoicesFieldDisplay: function () {
				var noinvoices = parseInt(jQuery(this).val());
				jQuery('.js-webpay-invoicesfield').css('display', 'none');

				jQuery('.js-webpay-invoicesfield').filter(function () {
					return jQuery(this).attr("data-i") < noinvoices;
				}).css('display', 'table');
			},

			/**
			 * Initiate the UI components for the payment form
			 *
			 * @see https://docs.unzer.com/online-payments/ui-component/#initiate-ui-components
			 */
			initialiseUnzerComponentsUi: function () {
				var unzerInstance = new unzer(flocertUnzer.publicKey);
				let card = unzerInstance.Card();
				global.card = card;
				card.create('number', {
					containerId: 'card-element-id-number',
					onlyIframe: false
				});
				card.create('expiry', {
					containerId: 'card-element-id-expiry',
					onlyIframe: false
				});
				card.create('cvc', {
					containerId: 'card-element-id-cvc',
					onlyIframe: false
				});
			},
			/**
			 * Handles the payment process.
			 *
			 * After form submission, a card resource is obtained, and a charge is performed
			 * via a REST endpoint using the Unzer PHP SDK. The payment resource is saved in
			 * a cookie as 3DS redirection does not contain the payment ID.
			 *
			 * Once 3DS is complete, we redirect to the payment handler, which retrieves the
			 * final payment status from the Unzer API.
			 *
			 * Workflow diagam below:
			 * @see https://docs.unzer.com/card/card.drawio.svg
			 */
			handleUnzerPayment: function () {
				let form = document.getElementById('payment-form');
				if (!document.getElementById('payment-form')) {
					return;
				}
				let $errorHolder = jQuery('#payment-form-errors');
				let $loadingOverlay = jQuery('.payment-form-loading');
				form.addEventListener('submit', function (event) {
					event.preventDefault();
					$loadingOverlay.show();
					$errorHolder.html('');
					global.card.createResource()
						.then(function (result) {
							let reference_number = document.querySelector('input[name="reference_number"]').value;
							let noorgs = document.querySelector('input[name="noorgs"]').value;
							let noinvoices = document.querySelector('input[name="noinvoices"]').value;
							let charge_request = {
								'resourceResponse': result,
								'paymentFor': document.querySelector('input[name="payment_for"]').value,
								'customer': document.querySelector('input[name="customer"]').value,
								'reference_number': reference_number,
								'organisation': document.querySelector('input[name="organisation"]').value,
								'noorgs': document.querySelector('input[name="noorgs"]')?.value,
								'noinvoices': document.querySelector('input[name="noinvoices"]')?.value,
								'customer_comments': document.querySelector('input[name="customer_comments"]').value,
							};
							for (let i = 0; i < noorgs; i++) {
								charge_request[`orgname_${i}`] = document.querySelector(`input[name="orgname_${i}"]`)?.value;
								charge_request[`orgcountry_${i}`] = document.querySelector(`input[name="orgcountry_${i}"]`)?.value;
								charge_request[`floid_${i}`] = document.querySelector(`input[name="floid_${i}"]`)?.value;
							}
							for (let i = 0; i < noinvoices; i++) {
								charge_request[`orgname_${i}`] = document.querySelector(`input[name="orgname_${i}"]`)?.value;
								charge_request[`floid_${i}`] = document.querySelector(`input[name="floid_${i}"]`)?.value;
								charge_request[`invoiceno_${i}`] = document.querySelector(`input[name="invoiceno_${i}"]`)?.value;
							}
							fn.store_details_as_cookie('charge_request', charge_request);
							fetch('/wp-json/flocert/v1/charge', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json'
								},
								body: JSON.stringify(charge_request)
							})
								.then(response => response.json())
								.then(data => {
									fn.store_details_as_cookie('charge_response', data);
									if (data.is_3ds) {
										window.location.href = data.redirect_url_3ds;
									} else if (data.success) {
										window.location.href = '/flopaymenthandler';
									} else {
										$errorHolder.html(data.message);
										$loadingOverlay.hide();
									}
								})
								.catch((error) => {
									console.error(error);
									$errorHolder.html('An error occured');
									$loadingOverlay.hide();
								});
						})
						.catch(function (error) {
							$errorHolder.html(error.message);
							console.error(error);
							$loadingOverlay.hide();
						})
				});
			},


			/**
			 * Store JSON in a cookie
			 *
			 * @param {string} cookie_name
			 * @param {JSON} data
			 */
			store_details_as_cookie: function (cookie_name, data) {
				let cookieValue = JSON.stringify(data);
				document.cookie = cookie_name + '=' + cookieValue + '; path=/';
			},
		}

		fn.init();
	}

	new FloUnzerPayments();
})(jQuery);